{
  "mercury.mercury-groups-configure-permissions.message-template.email.configurePermissions": [
    {
      "type": 0,
      "value": "Manage permissions"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.footerText": [
    {
      "type": 0,
      "value": "You received this email because you’re a Focus app admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.footerTextRedacted": [
    {
      "type": 0,
      "value": "You received this email because you’re a Focus app admin for your organization."
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.heading": [
    {
      "type": 0,
      "value": "Review permissions for Focus user groups"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.introduction": [
    {
      "type": 0,
      "value": "Some user groups in your organization require your attention. This happens when:"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.introductionItem1": [
    {
      "type": 0,
      "value": "1. A new group has been added to Focus, or"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.introductionItem2": [
    {
      "type": 0,
      "value": "2. An existing group's role for the Focus app has changed in Atlassian Administration."
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.learnMore": [
    {
      "type": 0,
      "value": "Learn more about group permissions"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Action needed: review permissions in the Focus app"
    }
  ],
  "mercury.mercury-groups-configure-permissions.message-template.email.whatToDoNext": [
    {
      "type": 0,
      "value": "Please review and enable permissions for these groups so impacted users can start using Focus."
    }
  ],
  "mercury.mercury-monthly-digest.email.arrow-icon.alt": [
    {
      "type": 0,
      "value": "arrow-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.arrow-right-icon.alt": [
    {
      "type": 0,
      "value": "arrow-right-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.calendar-icon.alt": [
    {
      "type": 0,
      "value": "calendar-icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.catch.up.link": [
    {
      "type": 0,
      "value": "Jump into Atlassian Focus"
    }
  ],
  "mercury.mercury-monthly-digest.email.catch.up.text": [
    {
      "type": 0,
      "value": "Want to catch up on previous updates? "
    },
    {
      "type": 1,
      "value": "link"
    }
  ],
  "mercury.mercury-monthly-digest.email.date-changed": [
    {
      "type": 0,
      "value": "Date Changed"
    }
  ],
  "mercury.mercury-monthly-digest.email.focus-area-icon.alt": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.atlassian-logo.alt": [
    {
      "type": 0,
      "value": "Atlassian footer"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-monthly-digest.email.footer.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "mercury.mercury-monthly-digest.email.for": [
    {
      "type": 0,
      "value": "for"
    }
  ],
  "mercury.mercury-monthly-digest.email.header.logoAltText": [
    {
      "type": 0,
      "value": "Focus Logo"
    }
  ],
  "mercury.mercury-monthly-digest.email.no-target-date.alt": [
    {
      "type": 0,
      "value": "No target date set"
    }
  ],
  "mercury.mercury-monthly-digest.email.status-changed": [
    {
      "type": 0,
      "value": "Status changed"
    }
  ],
  "mercury.mercury-monthly-digest.email.total-following.sub-header": [
    {
      "type": 0,
      "value": "You're following "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " active focus areas, here's the breakdown."
    }
  ],
  "mercury.mercury-monthly-digest.email.view-update": [
    {
      "type": 0,
      "value": "View Update"
    }
  ],
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", here are your monthly focus area updates"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.focus-logo.alt-text": [
    {
      "type": 0,
      "value": "Focus logo"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.body.multiple.no-translate": [
    {
      "type": 0,
      "value": "Your focus areas are off to a great start, but they're missing a few key pieces to unlock their full value. Complete setup in just a few minutes:"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.body.single.no-translate": [
    {
      "type": 0,
      "value": "Your focus area is off to a great start, but it's missing a few key pieces to unlock its full value. Complete setup in just a few minutes:"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.multiple.no-translate": [
    {
      "type": 0,
      "value": "View Your Focus Areas"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.cta.single.no-translate": [
    {
      "type": 0,
      "value": "View Focus Area"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.description.no-translate": [
    {
      "type": 0,
      "value": "Use the About section to describe what success looks like and why "
    },
    {
      "type": 1,
      "value": "focusAreaName"
    },
    {
      "type": 0,
      "value": " matters to your team."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.add-context.title.no-translate": [
    {
      "type": 0,
      "value": "Add more context"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.description.no-translate": [
    {
      "type": 0,
      "value": "Invite teammates as followers so they're automatically notified of important updates and milestones."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.bring-in-team.title.no-translate": [
    {
      "type": 0,
      "value": "Bring in your team"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.description.no-translate": [
    {
      "type": 0,
      "value": "Link your Goals and work from Jira Align, Jira Software, and Atlassian Projects to get strategic insights on execution."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.default-step.connect-work-goals.title.no-translate": [
    {
      "type": 0,
      "value": "Connect work & goals"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.focus-area-icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.atlassian-logo-alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.sent-by.no-translate": [
    {
      "type": 0,
      "value": "This email was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.footer.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "unsubscribe"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.greeting.no-translate": [
    {
      "type": 0,
      "value": "👋 Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.more-link.no-translate": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.pre-header.no-translate": [
    {
      "type": 0,
      "value": "Connect work, add context, and bring your team in."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.body.no-translate": [
    {
      "type": 0,
      "value": "Complete setup to help your team stay aligned on strategy."
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.button.no-translate": [
    {
      "type": 0,
      "value": "Go to Focus"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.second-cta.heading.no-translate": [
    {
      "type": 0,
      "value": "Ready to jump back into Focus?"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.multiple.no-translate": [
    {
      "type": 1,
      "value": "focusAreaName"
    },
    {
      "type": 0,
      "value": " and others are empty — let's get started"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.multiple.no-translate": [
    {
      "type": 0,
      "value": "Your focus areas are empty — let's get started"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.redacted.single.no-translate": [
    {
      "type": 0,
      "value": "Your focus area is empty — let's get started"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.subject.single.no-translate": [
    {
      "type": 1,
      "value": "focusAreaName"
    },
    {
      "type": 0,
      "value": " is empty — let's get started"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.multiple.no-translate": [
    {
      "type": 0,
      "value": "3 ways to bring your focus areas to life:"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.three-ways-heading.no-translate": [
    {
      "type": 0,
      "value": "3 ways to bring your focus area to life:"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.title.multiple.no-translate": [
    {
      "type": 0,
      "value": "Let's get your focus areas set up for success"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.title.single.no-translate": [
    {
      "type": 0,
      "value": "Let's get your focus area set up for success"
    }
  ],
  "mercury.mercury-re-engage-empty-focus-area.message-template.email.view-focus-area-button.no-translate": [
    {
      "type": 0,
      "value": "View Focus Area"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.focus-logo.alt-text": [
    {
      "type": 0,
      "value": "Focus logo"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.body.multiple.no-translate": [
    {
      "type": 0,
      "value": "It's been a while since your focus areas were updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.body.single.no-translate": [
    {
      "type": 0,
      "value": "It's been a while since your focus area was updated. Sharing regular updates keeps everyone aligned and helps your team understand progress."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature-highlights.heading.no-translate": [
    {
      "type": 0,
      "value": "Now it's even easier to write updates"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature-icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Feature icon"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.description.no-translate": [
    {
      "type": 0,
      "value": "Need help drafting an update? Use Rovo to **summarize** focus areas and quickly surface key risks, highlights, challenges, and more."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.ai-summary.title.no-translate": [
    {
      "type": 0,
      "value": "AI Summary"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.description.no-translate": [
    {
      "type": 0,
      "value": "Record a **Loom** directly in the update composer to walk teammates through key details and add a personal touch."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.inline-looms.title.no-translate": [
    {
      "type": 0,
      "value": "In-line Looms"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.description.no-translate": [
    {
      "type": 0,
      "value": "Set up **automations** to send a notification via Slack, Microsoft Teams, or email whenever you post an update."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.feature.update-notifications.title.no-translate": [
    {
      "type": 0,
      "value": "Update Notifications"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.focus-area-illustration.alt.no-translate": [
    {
      "type": 0,
      "value": "Focus area update workflow illustration"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.footer.atlassian-logo-alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.footer.sent-by.no-translate": [
    {
      "type": 0,
      "value": "This email was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.footer.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "unsubscribe"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.greeting.no-translate": [
    {
      "type": 0,
      "value": "👋 Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.last-update-text.no-translate": [
    {
      "type": 0,
      "value": "Last updated "
    },
    {
      "type": 1,
      "value": "relativeDate"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.more-link.no-translate": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.post-update-button.no-translate": [
    {
      "type": 0,
      "value": "Post Update"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.pre-header.no-translate": [
    {
      "type": 0,
      "value": "Keep your team aligned with your latest progress."
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.body.no-translate": [
    {
      "type": 0,
      "value": "Update your team and keep momentum going"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.button.no-translate": [
    {
      "type": 0,
      "value": "Go to Focus"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.second-cta.heading.no-translate": [
    {
      "type": 0,
      "value": "Ready to jump back into Focus?"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.subject.multiple.no-translate": [
    {
      "type": 1,
      "value": "focusAreaName"
    },
    {
      "type": 0,
      "value": " and others are waiting for an update"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.multiple.no-translate": [
    {
      "type": 0,
      "value": "Your focus areas are waiting for an update"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.subject.redacted.single.no-translate": [
    {
      "type": 0,
      "value": "Your focus area is waiting for an update"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.subject.single.no-translate": [
    {
      "type": 1,
      "value": "focusAreaName"
    },
    {
      "type": 0,
      "value": " is waiting for an update"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.title.multiple.no-translate": [
    {
      "type": 0,
      "value": "Share what's new with your focus areas"
    }
  ],
  "mercury.mercury-re-engage-pending-status-update.message-template.email.title.single.no-translate": [
    {
      "type": 0,
      "value": "Share what's new with your focus area"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.description.no-translate": [
    {
      "type": 0,
      "value": "Create custom fields (text, number, and select) for Focus areas to capture the data that matters most."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.custom-fields.title.no-translate": [
    {
      "type": 0,
      "value": "Custom Fields"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.description.no-translate": [
    {
      "type": 0,
      "value": "Control who can edit each Focus area to maintain clear ownership and precise access."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.focus-area-permissions.title.no-translate": [
    {
      "type": 0,
      "value": "Focus Area Permissions"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.description.no-translate": [
    {
      "type": 0,
      "value": "Automatically keep Jira work linked to the right Focus area based on custom field values in work items."
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.default.work-linking-automations.title.no-translate": [
    {
      "type": 0,
      "value": "Work Linking Automations"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.heading.no-translate": [
    {
      "type": 0,
      "value": "Feature highlights"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.icon.alt.no-translate": [
    {
      "type": 0,
      "value": "Feature icon"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "mercury.mercury-re-engage-whats-new.feature-highlights.subheading.no-translate": [
    {
      "type": 0,
      "value": "See what's new and improved in Focus."
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.heading.no-translate": [
    {
      "type": 0,
      "value": "Your team has created "
    },
    {
      "type": 1,
      "value": "noOfFocusAreas"
    },
    {
      "type": 0,
      "value": " new focus areas — follow to get notified of progress."
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.more-link.no-translate": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.owned-heading.no-translate": [
    {
      "type": 0,
      "value": "Focus areas you own"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.recently-created-heading.no-translate": [
    {
      "type": 0,
      "value": "Focus areas your team has created"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.view-all.no-translate": [
    {
      "type": 0,
      "value": "View all Focus Areas"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area-summary.watched-heading.no-translate": [
    {
      "type": 0,
      "value": "Focus areas you follow"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created-by.no-translate": [
    {
      "type": 1,
      "value": "relativeDate"
    },
    {
      "type": 0,
      "value": " · created by "
    },
    {
      "type": 1,
      "value": "userName"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created-date.no-translate": [
    {
      "type": 1,
      "value": "relativeDate"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.days-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.hours-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " hour ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " hours ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.minutes-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " minute ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " minutes ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.months-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " month ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " months ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.seconds-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=0": {
          "value": [
            {
              "type": 0,
              "value": "just now"
            }
          ]
        },
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " second ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconds ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.created.weeks-ago.no-translate": [
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " week ago"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " weeks ago"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.icon.alt-text": [
    {
      "type": 0,
      "value": "Focus area icon"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status-date.no-translate": [
    {
      "type": 1,
      "value": "status"
    },
    {
      "type": 0,
      "value": " • "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.at-risk.no-translate": [
    {
      "type": 0,
      "value": "At Risk"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.completed.no-translate": [
    {
      "type": 0,
      "value": "Completed"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.off-track.no-translate": [
    {
      "type": 0,
      "value": "Off Track"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.on-track.no-translate": [
    {
      "type": 0,
      "value": "On Track"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.paused.no-translate": [
    {
      "type": 0,
      "value": "Paused"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-area.status.pending.no-translate": [
    {
      "type": 0,
      "value": "Pending"
    }
  ],
  "mercury.mercury-re-engage-whats-new.focus-logo.alt-text": [
    {
      "type": 0,
      "value": "Focus logo"
    }
  ],
  "mercury.mercury-re-engage-whats-new.follow-button.no-translate": [
    {
      "type": 0,
      "value": "Follow"
    }
  ],
  "mercury.mercury-re-engage-whats-new.innovation-spotlight.cta-text.no-translate": [
    {
      "type": 0,
      "value": "Read the Blog"
    }
  ],
  "mercury.mercury-re-engage-whats-new.innovation-spotlight.description.no-translate": [
    {
      "type": 0,
      "value": "Want to learn more? Check out everything that's shipped in Strategy Collection since Team '25 Europe."
    }
  ],
  "mercury.mercury-re-engage-whats-new.innovation-spotlight.heading.no-translate": [
    {
      "type": 0,
      "value": "See the full Innovation Spotlight"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.banner.alt.no-translate": [
    {
      "type": 0,
      "value": "Strategy Collection"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.atlassian-logo-alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.sent-by.no-translate": [
    {
      "type": 0,
      "value": "This email was sent to you by Atlassian Focus"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.footer.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.header.greeting.no-translate": [
    {
      "type": 0,
      "value": "👋 Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.header.no-translate": [
    {
      "type": 0,
      "value": "Welcome to your Focus snapshot"
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.pre-header.no-translate": [
    {
      "type": 0,
      "value": "Catch up on your Focus areas and explore what's new."
    }
  ],
  "mercury.mercury-re-engage-whats-new.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your Focus Snapshot"
    }
  ],
  "mercury.mercury-re-engage-whats-new.test-message.email.header.sub-text.no-translate": [
    {
      "type": 0,
      "value": "Your bi-monthly update on the Focus areas you care about — plus what's new."
    }
  ],
  "mercury.mercury-re-engage-whats-new.view-focus-area-button.no-translate": [
    {
      "type": 0,
      "value": "View Focus Area"
    }
  ],
  "mercury.mercury-risk-assigned-owner.notification-drawer.message.title.no-translate": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " made you the owner of a risk"
    }
  ],
  "mercury.mercury-risk-assigned-owner.notification-drawer.path.status.no-translate": [
    {
      "type": 0,
      "value": "Risk • "
    },
    {
      "type": 1,
      "value": "status"
    }
  ],
  "mercury.mercury-risk-assigned-submitter.notification-drawer.message.title.no-translate": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " made you the submitter of a risk"
    }
  ],
  "mercury.mercury-risk-assigned-submitter.notification-drawer.path.status.no-translate": [
    {
      "type": 0,
      "value": "Risk • "
    },
    {
      "type": 1,
      "value": "status"
    }
  ],
  "mercury.mercury-risk-updated-date.message-template.notification-drawer.message.no-translate": [
    {
      "type": 1,
      "value": "actorName"
    },
    {
      "type": 0,
      "value": " updated your page"
    }
  ]
}